import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const CompanyApi = {
  Paginated: {
    useQuery: (dto: server.dto.PaginatedCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapperWithRequest<server.dto.CompanyForList[], server.dto.ListCompanyFilters>>) => useQuery({
      queryKey: ["Company.Paginated", dto],
      queryFn: () => window.CoreApi.Company.Paginated(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedCompanyInstruction) => ["Company.Paginated", dto]
  }, 
  PaginatedFiles: {
    useQuery: (dto: server.dto.PaginatedFileInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.File[]>>) => useQuery({
      queryKey: ["Company.PaginatedFiles", dto],
      queryFn: () => window.CoreApi.Company.PaginatedFiles(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedFileInstruction) => ["Company.PaginatedFiles", dto]
  }, 
  PaginatedEmails: {
    useQuery: (dto: server.dto.PaginatedEmailInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.EmailMessage[]>>) => useQuery({
      queryKey: ["Company.PaginatedEmails", dto],
      queryFn: () => window.CoreApi.Company.PaginatedEmails(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedEmailInstruction) => ["Company.PaginatedEmails", dto]
  }, 
  PaginatedSmall: {
    useQuery: (dto: server.dto.PaginatedCompanyInstruction, type: server.dto.AddressTypes, opts: UseQueryOptions<server.dto.ApiResponseWrapperWithRequest<server.dto.CompanySmall[], server.dto.ListCompanyFilters>>) => useQuery({
      queryKey: ["Company.PaginatedSmall", dto, type],
      queryFn: () => window.CoreApi.Company.PaginatedSmall(dto, type).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedCompanyInstruction, type: server.dto.AddressTypes) => ["Company.PaginatedSmall", dto, type]
  }, 
  ListRelatedFiles: {
    useQuery: (companyId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.RelatedFiles>>) => useQuery({
      queryKey: ["Company.ListRelatedFiles", companyId],
      queryFn: () => window.CoreApi.Company.ListRelatedFiles(companyId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number) => ["Company.ListRelatedFiles", companyId]
  }, 
  GetSidePanelData: {
    useQuery: (companyId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.CompanySidePanelData>>) => useQuery({
      queryKey: ["Company.GetSidePanelData", companyId],
      queryFn: () => window.CoreApi.Company.GetSidePanelData(companyId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number) => ["Company.GetSidePanelData", companyId]
  }, 
  CanReceivePeppol: {
    useQuery: (companyId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.CompanyCanReceivePeppol>>) => useQuery({
      queryKey: ["Company.CanReceivePeppol", companyId],
      queryFn: () => window.CoreApi.Company.CanReceivePeppol(companyId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number) => ["Company.CanReceivePeppol", companyId]
  }, 
  Restore: {
    useQuery: (companyId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.Restore", companyId],
      queryFn: () => window.CoreApi.Company.Restore(companyId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number) => ["Company.Restore", companyId]
  }, 
  GetProcessedEmailTemplate: {
    useQuery: (dto: server.dto.GetProcessedEmailTemplateInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.ProcessedEmailTemplate>>) => useQuery({
      queryKey: ["Company.GetProcessedEmailTemplate", dto],
      queryFn: () => window.CoreApi.Company.GetProcessedEmailTemplate(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.GetProcessedEmailTemplateInstruction) => ["Company.GetProcessedEmailTemplate", dto]
  }, 
  Create: {
    useQuery: (dto: server.dto.CreateCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["Company.Create", dto],
      queryFn: () => window.CoreApi.Company.Create(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.CreateCompanyInstruction) => ["Company.Create", dto]
  }, 
  Update: {
    useQuery: (dto: server.dto.UpdateCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.Update", dto],
      queryFn: () => window.CoreApi.Company.Update(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateCompanyInstruction) => ["Company.Update", dto]
  }, 
  Merge: {
    useQuery: (dto: server.dto.MergeCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.Merge", dto],
      queryFn: () => window.CoreApi.Company.Merge(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.MergeCompanyInstruction) => ["Company.Merge", dto]
  }, 
  AllowMerge: {
    useQuery: (dto: server.dto.AllowMergeCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<boolean>>) => useQuery({
      queryKey: ["Company.AllowMerge", dto],
      queryFn: () => window.CoreApi.Company.AllowMerge(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.AllowMergeCompanyInstruction) => ["Company.AllowMerge", dto]
  }, 
  Validate: {
    useQuery: (dto: server.dto.ApproveCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.Validate", dto],
      queryFn: () => window.CoreApi.Company.Validate(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ApproveCompanyInstruction) => ["Company.Validate", dto]
  }, 
  UpdateTags: {
    useQuery: (dto: server.dto.UpdateParentTagsInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.UpdateTags", dto],
      queryFn: () => window.CoreApi.Company.UpdateTags(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateParentTagsInstruction) => ["Company.UpdateTags", dto]
  }, 
  SetBusinessCentralNumber: {
    useQuery: (dto: server.dto.SetBusinessCentralNumberInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.SetBusinessCentralNumber", dto],
      queryFn: () => window.CoreApi.Company.SetBusinessCentralNumber(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.SetBusinessCentralNumberInstruction) => ["Company.SetBusinessCentralNumber", dto]
  }, 
  SetHubSpotCompanyId: {
    useQuery: (dto: server.dto.SetHubSpotCompanyIdInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.SetHubSpotCompanyId", dto],
      queryFn: () => window.CoreApi.Company.SetHubSpotCompanyId(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.SetHubSpotCompanyIdInstruction) => ["Company.SetHubSpotCompanyId", dto]
  }, 
  ExportItem: {
    useQuery: (companyId: number, exportAction: server.dto.ExportActions, clientFileName: string, wordTemplateId: number, preferredCulture: server.dto.LCID, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["Company.ExportItem", companyId, exportAction, clientFileName, wordTemplateId, preferredCulture],
      queryFn: () => window.CoreApi.Company.ExportItem(companyId, exportAction, clientFileName, wordTemplateId, preferredCulture).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number, exportAction: server.dto.ExportActions, clientFileName: string, wordTemplateId: number, preferredCulture: server.dto.LCID) => ["Company.ExportItem", companyId, exportAction, clientFileName, wordTemplateId, preferredCulture]
  }, 
  ExportList: {
    useQuery: (fileName: string, page: number, templateId: number, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["Company.ExportList", fileName, page, templateId],
      queryFn: () => window.CoreApi.Company.ExportList(fileName, page, templateId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (fileName: string, page: number, templateId: number) => ["Company.ExportList", fileName, page, templateId]
  }, 
  ExportEmails: {
    useQuery: (fileName: string, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["Company.ExportEmails", fileName],
      queryFn: () => window.CoreApi.Company.ExportEmails(fileName).then(r => r.data),
      ...opts
    }),
    getCacheKey: (fileName: string) => ["Company.ExportEmails", fileName]
  }, 
  ListActivity: {
    useQuery: (dto: server.dto.PaginatedItemActivityInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.CompanyActivity[]>>) => useQuery({
      queryKey: ["Company.ListActivity", dto],
      queryFn: () => window.CoreApi.Company.ListActivity(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedItemActivityInstruction) => ["Company.ListActivity", dto]
  }, 
  ExportOptionsForList: {
    useQuery: (dto: server.dto.PaginatedCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.ExportOption[]>>) => useQuery({
      queryKey: ["Company.ExportOptionsForList", dto],
      queryFn: () => window.CoreApi.Company.ExportOptionsForList(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedCompanyInstruction) => ["Company.ExportOptionsForList", dto]
  }, 
  ExportOptionsForDetail: {
    useQuery: (companyId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.ExportOption[]>>) => useQuery({
      queryKey: ["Company.ExportOptionsForDetail", companyId],
      queryFn: () => window.CoreApi.Company.ExportOptionsForDetail(companyId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (companyId: number) => ["Company.ExportOptionsForDetail", companyId]
  }, 
  NameExists: {
    useQuery: (dto: server.dto.CompanyNameExistsInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<boolean>>) => useQuery({
      queryKey: ["Company.NameExists", dto],
      queryFn: () => window.CoreApi.Company.NameExists(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.CompanyNameExistsInstruction) => ["Company.NameExists", dto]
  }, 
  UpdateMarker: {
    useQuery: (dto: server.dto.UpdateCompanyGeoCodeOnMapInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Company.UpdateMarker", dto],
      queryFn: () => window.CoreApi.Company.UpdateMarker(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateCompanyGeoCodeOnMapInstruction) => ["Company.UpdateMarker", dto]
  }, 

}
